import GeoContext from 'contexts/geoContext'
import useExperienceSearchList from 'hooks/Experiences/useExperienceSearchList'
import { useAppSelector } from 'hooks/reduxHooks'
import { usePlaceById, usePlaceByCoords } from 'hooks/usePlace'
import { useContext } from 'react'

function useHomepageExperiencePlace() {
  const geo = useContext(GeoContext)
  const experiencePlace = useAppSelector(state => state.experience.experiencePlace)

  const selectedPlace = usePlaceById(experiencePlace.placeId)
  const [geoPlace] = usePlaceByCoords(geo.latitude, geo.longitude)
  const currentPlace = experiencePlace.type === 'currentLocation' ? geoPlace : selectedPlace
  const isAutomaticRegionFallback = experiencePlace.type === 'region' && !experiencePlace.userSelected
  const shouldCheckLocalAvailability = !!currentPlace && !isAutomaticRegionFallback

  const list = useExperienceSearchList({
    placeId: currentPlace?.id,
    sortBy: 'recommended',
    enabled: shouldCheckLocalAvailability,
  })

  if (!shouldCheckLocalAvailability || (!list.fetching && list.ids.length === 0)) {
    return undefined
  }

  return currentPlace
}

export default useHomepageExperiencePlace
